import React from 'react';
import './Footer.css'

const Footer = () => {
	return <div className='footer-box'> Copyright &copy; Modezp</div>;
};

export default Footer;
